import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { ParticipantProvider } from '@/contexts/ParticipantContext';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { AppShell } from '@/components/layout/AppShell';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';

import {
  LoginPage, RegisterPage, MFAVerifyPage, DashboardPage, OnboardingPage,
  InvestmentHub, FundMenu, OrderHistory, FundDetail, BrokerageWindow,
  BlindTrustPortal, LoansPage, BeneficiariesPage, IFTPage, RetirementToolsPage,
  NewsPage, ContributionEditorPage, FundAllocationPage, ContributionLimitsPage,
  RetirementProjectionPage, PensionRMDPage, AnnuityEstimatorPage, ProfilePage, DocumentsPage,
  CompliancePage, SSOCallbackPage, SSOErrorPage, SettingsPage,
} from '@/pages';
import { OGEComplianceDashboard } from '@/components/OGEComplianceDashboard';

function ProtectedWithShell({ children }) {
  return (
    <ProtectedRoute>
      <AppShell>{children}</AppShell>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <AuthProvider>
      <ParticipantProvider>
        <BrowserRouter>
        <div className="App">
          <Routes>
            {/* Public */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/mfa-verify" element={<MFAVerifyPage />} />
            <Route path="/auth/sso/callback" element={<SSOCallbackPage />} />
            <Route path="/auth/sso/error" element={<SSOErrorPage />} />

            {/* Protected */}
            <Route path="/onboarding" element={<ProtectedRoute><OnboardingPage /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedWithShell><DashboardPage /></ProtectedWithShell>} />
            <Route path="/investments" element={<ProtectedWithShell><InvestmentHub /></ProtectedWithShell>} />
            <Route path="/funds" element={<ProtectedWithShell><FundMenu /></ProtectedWithShell>} />
            <Route path="/funds/:symbol" element={<ProtectedWithShell><FundDetail /></ProtectedWithShell>} />
            <Route path="/investments/orders" element={<ProtectedWithShell><OrderHistory /></ProtectedWithShell>} />
            <Route path="/investments/brokerage" element={<ProtectedWithShell><BrokerageWindow /></ProtectedWithShell>} />
            <Route path="/compliance/oge" element={<ProtectedWithShell><OGEComplianceDashboard /></ProtectedWithShell>} />
            <Route path="/compliance" element={<ProtectedWithShell><CompliancePage /></ProtectedWithShell>} />
            <Route path="/trust/portal" element={<ProtectedWithShell><BlindTrustPortal /></ProtectedWithShell>} />
            <Route path="/loans" element={<ProtectedWithShell><LoansPage /></ProtectedWithShell>} />
            <Route path="/beneficiaries" element={<ProtectedWithShell><BeneficiariesPage /></ProtectedWithShell>} />
            <Route path="/ift" element={<ProtectedWithShell><IFTPage /></ProtectedWithShell>} />
            <Route path="/retirement-tools" element={<ProtectedWithShell><RetirementToolsPage /></ProtectedWithShell>} />
            <Route path="/news" element={<ProtectedWithShell><NewsPage /></ProtectedWithShell>} />
            <Route path="/contributions" element={<ProtectedWithShell><ContributionEditorPage /></ProtectedWithShell>} />
            <Route path="/fund-allocation" element={<ProtectedWithShell><FundAllocationPage /></ProtectedWithShell>} />
            <Route path="/contribution-limits" element={<ProtectedWithShell><ContributionLimitsPage /></ProtectedWithShell>} />
            <Route path="/retirement-projection" element={<ProtectedWithShell><RetirementProjectionPage /></ProtectedWithShell>} />
            <Route path="/pension-rmd" element={<ProtectedWithShell><PensionRMDPage /></ProtectedWithShell>} />
            <Route path="/annuity" element={<ProtectedWithShell><AnnuityEstimatorPage /></ProtectedWithShell>} />
            <Route path="/profile" element={<ProtectedWithShell><ProfilePage /></ProtectedWithShell>} />
            <Route path="/documents" element={<ProtectedWithShell><DocumentsPage /></ProtectedWithShell>} />
            <Route path="/settings" element={<ProtectedWithShell><SettingsPage /></ProtectedWithShell>} />

            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
          <Toaster />
        </div>
      </BrowserRouter>
      </ParticipantProvider>
    </AuthProvider>
  );
}

export default App;
